<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/F81Qvy/tc-custom/9781446359822.jpg?1726454433084" alt="This image is the cover for the book Seasonal Push Pop Cakes, Bake Me I'm Yours . . ."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seasonal Push Pop Cakes, Bake Me I'm Yours . . .
      </h1>
      <p class="bookDescription body article font2">
        <p>A beginner-friendly collection of more than 10 push pop cake designs for seasonal celebrations, featuring simple sugarpaste decorations and colourful, tasty cake and filling combinations. From New Year to Easter, Valentine's Day to the 4th of July, Halloween to Christmas, this eBook covers the best seasonal celebration cake recipes and sugarcraft ideas. The designs look great but are also easy to follow and quick to make, with tasty cake recipes and plenty of ideas for fillings and toppings.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katie Deacon
      </h2>
      
      <p class="authorDescription body article"><P><B>Katie Deacon</B> is a food and baking blogger who runs the highly-rated ‘Katie Cakes’ blog, as well as her new cupcake and baking shop Pet Lamb Patisserie, in Newcastle.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1767be0a